import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { PreferenciaNotificacao } from '../types'

export function usePreferenciasNotificacao() {
  return useQuery({
    queryKey: ['preferencias-notificacao'],
    queryFn: async () => {
      const r = await api.get<PreferenciaNotificacao[]>('/notificacoes/preferencias/')
      return r.data
    },
    staleTime: 1000 * 60 * 5,
  })
}

export function usePreferenciaNotificacaoUpdate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (vars: {
      tipo: string
      canal_inapp?: boolean
      canal_email?: boolean
    }) => {
      const { tipo, ...payload } = vars
      const r = await api.put<PreferenciaNotificacao>(
        `/notificacoes/preferencias/${tipo}/`,
        payload,
      )
      return r.data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['preferencias-notificacao'] }),
  })
}
